import { render } from "./ResultsAfter.vue?vue&type=template&id=d10da39a"
import script from "./ResultsAfter.vue?vue&type=script&lang=js"
export * from "./ResultsAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__